import { createUseStyles } from 'react-jss';

export const overviewTableStyles = createUseStyles({
  container: {

  },
});
